module.exports = __webpack_public_path__ + "static/sala_de_reuniones.min-42a8b9c1b6055b101dfe3a1d6a1bd96a.png";